import { useSelector } from 'react-redux';
import { headerPinSelector } from '../selectors/globalsSelectors';

export function useHeaderPin() {
  const headerPin = useSelector(headerPinSelector);
  return headerPin;
}
